'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

import styles from './SpecialistCertificateList.module.scss';

import { IFeature } from 'app/interfaces/common';
import { defaultProcessText } from 'app/utility/textProcessing';
import WithSwiper from 'app/components/common/WithSwiper';
import SwiperButtonPrev from 'app/components/common/SwiperButtonPrev';
import SwiperButtonNext from 'app/components/common/SwiperButtonNext';
import { useState } from 'react';
import classNames from 'classnames';

export default function SpecialistCertificateList({
  items
}: {
  items: IFeature[];
}) {
  const [isLocked, setIsLocked] = useState(false);

  return (
    <section className="wrapper-main wrapper-max relative w-full">
      <Swiper
        className={classNames(styles.slider, isLocked && styles.slider_locked)}
        slidesPerView={1}
        spaceBetween={0}
        breakpoints={{
          768: {
            slidesPerView: 2,
            spaceBetween: 80
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 70
          }
        }}
        onLock={() => setIsLocked(true)}
        onUnlock={() => setIsLocked(false)}
      >
        {items.map((item, index) => {
          return (
            <SwiperSlide key={index}>
              <div className="flex flex-col justify-between items-start gap-20">
                <div
                  className="text-p3"
                  dangerouslySetInnerHTML={{
                    __html: item.description_extra
                      ? defaultProcessText(item.description_extra)
                      : ''
                  }}
                ></div>
                <div className="flex flex-col justify-between items-start gap-9 md:gap-2.5">
                  <div
                    className="text-h1"
                    dangerouslySetInnerHTML={{
                      __html: defaultProcessText(item.title)
                    }}
                  ></div>
                  {!!item.description && (
                    <div
                      className="text-p3"
                      dangerouslySetInnerHTML={{
                        __html: defaultProcessText(item.description)
                      }}
                    ></div>
                  )}
                </div>
              </div>
            </SwiperSlide>
          );
        })}
        <WithSwiper>
          {({ isLocked }) =>
            !isLocked && (
              <div className="absolute bottom-0 right-3.5 z-10 flex gap-1 justify-end">
                <SwiperButtonPrev />
                <SwiperButtonNext />
              </div>
            )
          }
        </WithSwiper>
      </Swiper>
    </section>
  );
}
